
export default function Banner({children}) {
  return (
    <div className="banner">
      <span className="title">{children}</span>
    </div>
  )
}
